import { useEffect, useMemo, useState } from "react";
import { Typography } from "antd";
import { PRODUCT_LINKS } from "constants";
import "./OliveebProductAds.css";

const { Text } = Typography;

export const OLIVEEB_PRODUCT_ADS = [
  {
    name: "Olreadia",
    text: "Apply for jobs, hire talent AI verified professionals, transparent interviewing processes .",
    url: PRODUCT_LINKS.olreadia,
    logo: "/oliveeb/olreadia.png",
    tone: "green",
  },
  {
    name: "Ovacus",
    text: "Manage projects, tasks, teams, product testing, and workflows in one powerful workspace.",
    url: PRODUCT_LINKS.ovacus,
    logo: "/oliveeb/ovacus.png",
    tone: "blue",
  },
  {
    name: "Ovizia",
    text: "Build websites faster with a visual composer with AI integration. No technical skills required .",
    url: PRODUCT_LINKS.ovizia,
    logo: "/oliveeb/ovizia.png",
    tone: "gold",
  },
  {
    name: "Olitask",
    text: "Get everyday tasks done by trusted local helpers whenever you need support. No more stress, just results.",
    url: PRODUCT_LINKS.olitask,
    logo: "/oliveeb/olitask.png",
    tone: "green",
  },
];

const OliveebProductAds = ({
  className = "",
  intervalMs = 5500,
  showHeader = true,
  compact = false,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeProductAd = useMemo(
    () => OLIVEEB_PRODUCT_ADS[activeIndex % OLIVEEB_PRODUCT_ADS.length],
    [activeIndex],
  );
  const activeDotIndex = activeIndex % OLIVEEB_PRODUCT_ADS.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((current) => (current + 1) % OLIVEEB_PRODUCT_ADS.length);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return (
    <section
      className={[
        "oliveeb-product-ads",
        compact ? "oliveeb-product-ads--compact" : "",
        className,
      ].filter(Boolean).join(" ")}
      aria-label="Sponsored Oliveeb product ads"
    >
      {showHeader ? (
        <div className="oliveeb-product-ads__header">
          <Text className="oliveeb-product-ads__title">Ads</Text>
          <span className="oliveeb-product-ads__label">Sponsored</span>
        </div>
      ) : null}

      <div className={`oliveeb-product-ad ${activeProductAd.tone}`}>
        <span className="oliveeb-product-ad__icon">
          <img src={activeProductAd.logo} alt={`${activeProductAd.name} logo`} />
        </span>
        <span className="oliveeb-product-ad__copy">
          <Text className="oliveeb-product-ad__title">{activeProductAd.name}</Text>
          <Text className="oliveeb-product-ad__text">
            {activeProductAd.text}{" "}
            <a
              className="oliveeb-product-ad__link"
              href={activeProductAd.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              Explore &gt;&gt;
            </a>
          </Text>
        </span>
      </div>

      <div className="oliveeb-product-ad__dots" aria-label="Oliveeb product ads">
        {OLIVEEB_PRODUCT_ADS.map((item, index) => (
          <button
            type="button"
            key={item.name}
            className={`oliveeb-product-ad__dot${index === activeDotIndex ? " is-active" : ""}`}
            onClick={() => setActiveIndex(index)}
            aria-label={`Show ${item.name} ad`}
          />
        ))}
      </div>
    </section>
  );
};

export default OliveebProductAds;
